import React, { useState, useEffect } from 'react';
import PersonalInfoUpdateForm from './Components/PersonalInfoUpdateForm';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import SignedConsentsTable from './Components/SignedConsentsTable';
import DekegatesAndConsents from './Components/DelegatesAndConsents';
import AccountDeletion from './Components/AccountDeletion';
import DiscountCards from './Components/DiscountCards';
import LoginCredentials from './Components/LoginCredentials';
import useFetch from 'use-http';
import {
  useUserState,
  useUserDispatch,
} from '@/components/context/UserContext';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogBody,
} from '@/components/ui/dialog';
import PersonalInfo from './Components/PersonalInfo';
import useEmailToken from '../../../components/hooks/useEmailToken';

const UserAccountMainPage = () => {
  const [PreviewEmailConfirmModalVisible, setPreviewEmailConfirmModalVisible] =
    useState(false);

  const { put: putUnifyPhoneNumber, response: putUnifyPhoneNumberResponse } =
    useFetch(`/UserAccount/unifyPhoneNumber`);
  const userState = useUserState();

  useEffect(() => {
    if (checkEmailToken().emailTokenExists) {
      if (userState.newEmail === null) {
        return;
      } else {
        setPreviewEmailConfirmModalVisible(true);
      }
    }
  }, [userState.newEmail]);

  const [
    checkEmailToken,
    sendUpdate,
    resetNewEmail,
    confirmToken,
    ,
    ,
    ,
    deleteNewEmail,
  ] = useEmailToken();

  const sessionDispatch = useUserDispatch();
  const childSelected = Boolean(userState?.espbiEsi);
  const [shouldShowUnifyPhoneNumberModal, setshouldShowUnifyPhoneNumberModal] =
    useState(false);

  const shouldUnifyPhoneNumber = () => {
    return (
      !userState.phoneNumberUnificationAsked &&
      userState.phoneNumberConfirmed &&
      userState.phoneNumberInAmis &&
      userState.phoneNumber &&
      userState.phoneNumberInAmis !== userState.phoneNumber &&
      userState.phoneNumberInAmis !== '+' //amis doesnt save foreign numbers. returns '+'. its to prevent asking for change and impacting user experience. TEMPORARY :)
    );
  };

  useEffect(() => {
    setshouldShowUnifyPhoneNumberModal(shouldUnifyPhoneNumber());
  }, []);

  const closeNumberUnificationModal = () => {
    setshouldShowUnifyPhoneNumberModal(false);
    sessionDispatch({
      type: 'UPDATE',
      data: {
        phoneNumberUnificationAsked: true,
      },
    });
  };

  return (
    <div className="w-full h-full">
      <div className="space-y-8 p-1">
        <PersonalInfo />
        <DekegatesAndConsents />
        <SignedConsentsTable />
        {!childSelected && <LoginCredentials />}
        {!childSelected && <AccountDeletion />}
      </div>

      <Dialog
        open={shouldShowUnifyPhoneNumberModal}
        onOpenChange={setshouldShowUnifyPhoneNumberModal}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Telefono numerio keitimas</DialogTitle>
          </DialogHeader>
          <DialogBody>
            Jūsų telefono numeris {userState.phoneNumberInAmis} nurodytas
            Affidea padalinyje nesutampa su telefonu {userState.phoneNumber}{' '}
            nurodytu portale mano.affidea.lt
            <br />
            Ar norite pakeisti ir portale naudoti numerį{' '}
            {userState.phoneNumberInAmis}?
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                closeNumberUnificationModal();
                putUnifyPhoneNumber({ phoneNumber: userState.phoneNumber });
              }}
            >
              Naudoti turimą numerį
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                closeNumberUnificationModal();
                putUnifyPhoneNumber({
                  phoneNumber: userState.phoneNumberInAmis,
                });
              }}
            >
              Pakeisti numerį
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={PreviewEmailConfirmModalVisible}
        onOpenChange={() => {
          resetNewEmail(checkEmailToken().emailToken);
          setPreviewEmailConfirmModalVisible(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>El. pašto adreso keitimas</DialogTitle>
          </DialogHeader>
          <DialogBody>
            {`Ar norite pakeisti savo el.pašto adresą iš ${userState.email} į ${userState.newEmail}?`}
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                sendUpdate(checkEmailToken().emailToken);
                setPreviewEmailConfirmModalVisible(false);
              }}
            >
              Taip
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                resetNewEmail(checkEmailToken().emailToken);
                setPreviewEmailConfirmModalVisible(false);
              }}
            >
              Ne
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UserAccountMainPage;
